(function ($) {

  jQuery('#create_customer button, #customer_login button, [action="/account/recover"] button, #ContactForm button').on('click', function () {
    // this adds 'required' class to all the required inputs under the same <form> as the submit button
    console.log($(this).closest('form').find('[required]'));
    jQuery(this).closest('form').find('[required]').addClass('required');
  });

  $(document).on('click', '.search_validation form button[type="submit"]', function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    var q = form.find('[name="q"]');
    var search_validation = form.closest('.search_validation');
    if (q.val() == "") {
      search_validation.addClass('requiredForm');
      q.addClass('required')
      return false;
    }
    form.submit();
  })

  $(document).on('focus', '[name="q"]', function (e) {
    var search_validation = $(this).closest('.search_validation');
    search_validation.removeClass('requiredForm');
    $(this).removeClass('required')
  })


  $(document).on('submit', '#wholesale_customer_form', function (e) {
    e.preventDefault();
    let form = $(this);
    form.addClass('loading');
    $.ajax({
      type: "POST",
      url: "https://tinybotvinyl.wolfmanapps.com/api/customer/wholesale",
      data: new FormData(form[0]),
      processData: false,
      contentType: false,
    }).done(function (data) {
      form.removeClass('loading');
      console.log(data);
      // form.find('.response-field .message').html(data.message);
      $('.submitted_form .certificate-grid').show();
      $('#wholesale_customer_form').hide();
    });
  });

  function getSubmittedDetails() {
    let element = $('.submitted_form');
    if (element.length != 0) {
      let customer_id = element.data('customer_id');
      $.ajax({
        type: "GET",
        url: "https://tinybotvinyl.wolfmanapps.com/api/customer/wholesale",
        data: { customer_id: customer_id },
        dataType: "json",
        encode: true,
      }).done(function (data) {
        if (data.success) {
          updateCertificateData(data.data);
        }
      });
    }
  }

  $(document).on('click', '.resubmit-form a', function (e) {
    e.preventDefault();
    $('.submitted_form .certificate-grid').hide();
    $('#wholesale_customer_form').show();
  });

  function updateCertificateData(data) {
    let element = $('.submitted_form .certificate-grid');
    if (data.length != 0) {
      $('.submitted_form .certificate-grid').show();
      $('#wholesale_customer_form').hide();
      // var keys = Object.keys(data);
      // var html = '';
      // html += `<div class="status-message"><h3>Submitted Certificates:</h3><p>Status: <strong>Your account is under reviewed.</strong></p></div>`;
      // html += `<div class="certificate-grid">`;
      // keys.forEach(function(item){
      //   html += `<div class="certificate-item">
      //               <label>${item}</label>
      //               <a href="${data[item]}">File Link</a>
      //           </div>`;
      // });
      // html += `</div>`;
      // element.html(html);
    } else {
      $('.submitted_form .certificate-grid').hide();
      $('#wholesale_customer_form').show();
    }
  }
  getSubmittedDetails();
})(jQuery);